import React, { Component } from 'react';
class FormExplanationValidation extends Component {

    componentDidUpdate() {
        // Check if the element is valid
        if (!(this.props.showValidation && this.props.validationText && this.props.validationText.length > 0 && this.props.id != null)) {
            return;
        }

        // Check if an unvalid element is already focused after button or hyperlink click
        var tagName = (document.activeElement == null ? "" : (document.activeElement.tagName == null) ? "" : document.activeElement.tagName.toLowerCase());
        var type = (document.activeElement == null ? "" : (document.activeElement.type == null) ? "" : document.activeElement.type.toLowerCase());
        if (!(tagName === "a" || type === "button")) {
            return;
        }

        // Focus the error element
        document.getElementById(this.props.id).focus();
    }
    render() {
        let explanationText = this.props.explanation ? <div className="ExplanationText">{this.props.explanation}</div> : null;        
        let validationText = null;

        if (this.props.showValidation && this.props.validationText) {
            validationText = <span className="EditingFormErrorLabel" style={{ display: "inline" }}>{this.props.validationText}</span>;
        }

        if (explanationText == null && validationText == null) {
            return "";
        }

        return (
            <div>
                {explanationText}
                {validationText}
            </div>
        );
    }
}

export default FormExplanationValidation;


// WEBPACK FOOTER //
// ./src/Fields/FormExplanationValidation.js